import routes from '../routes';
import reducer from './reducers/index';
import * as SurveySelectors from './selectors';
import * as SurveyOperations from './operations';
import * as SurveyActions from './actions';

export {
    SurveySelectors,
    SurveyOperations,
    SurveyActions
};

export default {
    routes,
    reducer
};
